import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iconInput", "iconColorInput", "colorInput", "preview", "iconPreview", "color", "iconColor", "iconsContainer", "customIcon"]

  connect() {
    this._isConnecting = true
    this.color = this.colorInputTarget.value
    this.icon = this.iconInputTarget.value
    this.iconColor = this.iconColorInputTarget.value
    this.updateStyles()
    this.loadIcons()
    this._isConnecting = false
  }

  loadIcons() {
    // Define grouped icons
    const groups = {
      "Shapes": [
        "fas fa-circle",
        "fas fa-star",
        "fas fa-certificate",
        "fas fa-shield-alt",
        "fas fa-infinity",
        "fas fa-crown",
        "fas fa-gem",
        "fas fa-retweet",
        "fas fa-wave-square",
        "fas fa-tasks",
        "fas fa-redo-alt",
        "fas fa-circle-half-stroke",
        "fas fa-chart-column",
        "fas fa-chart-pie",
        "fas fa-chart-line",
        "fas fa-diagram-project",
      ],
      "People": [
        "fas fa-user",
        "fas fa-user-tie",
        "fas fa-users",
        "fas fa-user-check",
        "fas fa-user-lock",
        "fas fa-user-shield",
        "fas fa-user-secret",
        "fas fa-ghost",
        "fas fa-mask",
        "fas fa-handshake",
        "fas fa-address-card",
        "fas fa-id-badge",
        "fas fa-address-book",
      ],
      "Files": [
        "fas fa-newspaper",
        "fas fa-file-signature",
        "fas fa-passport",
        "fas fa-file-word",
        "fas fa-file-powerpoint",
        "fas fa-file-code",
        "fas fa-file"
      ],
      "Devices & Hardware": [
        "fas fa-laptop",
        "fas fa-globe",
        "fas fa-phone",
        "fas fa-sim-card",
        "fas fa-mobile-alt",
        "fas fa-print",
        "fas fa-camera",
        "fas fa-video",
        "fas fa-fax",
        "fas fa-dice-d6",
        "fab fa-bluetooth",
        "fas fa-network-wired",
        "fas fa-database",
        "fas fa-hammer",
        "fas fa-wrench",
        "fas fa-screwdriver",
        "fas fa-plug",
        "fas fa-wifi",
        "fas fa-cloud",
        "fas fa-link",
        "fas fa-server",
        "fas fa-desktop",
        "fas fa-tablet-alt",
        "fas fa-router",
        "fas fa-hard-drive",
        "fas fa-ethernet",
      ],
      "Locations": [
        "fas fa-industry",
        "fas fa-landmark",
        "fas fa-house-damage",
        "fas fa-warehouse",
        "fas fa-map-marker-alt",
      ],
      "Misc.": [
        "fas fa-key",
        "fas fa-lightbulb",
        "fas fa-envelope",
        "fas fa-cog",
        "fas fa-bug",
        "fas fa-lock",
        "fas fa-magnet",
        "fas fa-spider",
        "fas fa-vials",
        "fas fa-terminal",
        "fas fa-ambulance",
        "fas fa-bell",
        "fas fa-dollar-sign",
        "fas fa-code",
        "fas fa-cloud-moon",
        "fas fa-charging-station",
        "fas fa-comments",
        "fas fa-fingerprint",
        "fas fa-fill",
        "fas fa-dumpster",
        "fas fa-fire",
        "fas fa-car",
      ],
      "Brands": [
        "fab fa-aws",
        "fab fa-chrome",
        "fab fa-edge",
        "fab fa-firefox",
        "fab fa-apple",
        "fab fa-google",
        "fab fa-microsoft",
        "fab fa-slack",
        "fab fa-wordpress",
        "fab fa-drupal",
        "fab fa-linux",
        "fab fa-windows",
        "fab fa-cloudflare",
      ],
    }
  
    this.iconsContainerTarget.innerHTML = "" // clear first
  
    // Build grouped sections
    Object.entries(groups).forEach(([groupName, icons]) => {
      const groupWrapper = document.createElement("div")
      groupWrapper.classList.add("icon-group")
  
      const title = document.createElement("p")
      title.textContent = groupName
      title.className = "form-builder-settings-text"
      groupWrapper.appendChild(title)
  
      const buttonsWrapper = document.createElement("div")
      buttonsWrapper.classList.add("icon-buttons-wrapper")
  
      icons.forEach((icon) => {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "form-builder-icon-button"
        button.innerHTML = `<i class="${icon}"></i>`
        button.dataset.icon = icon
        button.addEventListener("click", (e) => this.selectIconButton(e))
        if (this.icon === icon) {
          button.classList.add("selected")
        }
        buttonsWrapper.appendChild(button)
      })
  
      groupWrapper.appendChild(buttonsWrapper)
      this.iconsContainerTarget.appendChild(groupWrapper)
    })
  }

  selectIconButton(event) {
    const button = event.currentTarget
    const selectedIcon = button.dataset.icon

    this.icon = selectedIcon
    this.updateStyles()

    this.iconsContainerTarget.querySelectorAll(".form-builder-icon-button").forEach((btn) => {
      btn.classList.remove("selected")
    })
    button.classList.add("selected")

    if (this.hasCustomIconTarget) {
      let iconExistsInGroups = false;
      this.iconsContainerTarget
        .querySelectorAll(".form-builder-icon-button")
        .forEach(btn => {
          if (btn.dataset.icon === this.icon) {
            iconExistsInGroups = true
          }
        })

      if (!iconExistsInGroups) {
        this.customIconTarget.value = this.icon
      }
    }
  }

  updateColor(event) {
    this.color = event.target.value
    this.updateStyles()
  }

  updateIconColor(event) {
    this.iconColor = event.target.value
    this.updateStyles()
  }

  updateIcon(event) {
    this.icon = event.target.value
    this.updateStyles()
  }

  updateStyles() {
    this.colorInputTarget.value = this.color
    this.iconColorInputTarget.value = this.iconColor
    this.iconInputTarget.value = this.icon
    this.previewTarget.style.background = this.color
    this.iconPreviewTarget.className = this.icon
    this.iconPreviewTarget.style.color = this.iconColor

    // Programmatic `.value=` does not fire input/change events, so a click on
    // an icon button (which writes to the hidden inputs) would otherwise be
    // invisible to the autosave controller. Dispatch a bubbling `change` so it
    // hears the update; skip during initial connect to avoid a redundant save.
    if (!this._isConnecting) {
      this.iconInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
